import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable()
export class LayoutViewerService {
    splitedView = false;
    expandedLeftPanel = true;
    expandedRightPanel = true;

    splitedView$ = new Subject<boolean>();
    expandedLeftPanel$ = new Subject<boolean>();
    expandedRightPanel$ = new Subject<boolean>();

    splitWidgetView(): void {
        this.splitedView = true;
        this.splitedView$.next(this.splitedView);
    }

    joinWidgetView(): void {
        this.splitedView = false;
        this.splitedView$.next(this.splitedView);
    }

    toggleWidgetView(): void {
        this.splitedView = !this.splitedView;
        this.splitedView$.next(this.splitedView);
    }

    expandLeftPanel(): void {
        this.expandedLeftPanel = true;
        this.expandedLeftPanel$.next(this.expandedLeftPanel);
    }

    collapseLeftPanel(): void {
        this.expandedLeftPanel = false;
        this.expandedLeftPanel$.next(this.expandedLeftPanel);
    }

    toggleLeftPanel(): void {
        this.expandedLeftPanel = !this.expandedLeftPanel;
        this.expandedLeftPanel$.next(this.expandedLeftPanel);
    }

    expandRightPanel(): void {
        this.expandedRightPanel = true;
        this.expandedRightPanel$.next(this.expandedRightPanel);
    }

    collapseRightPanel(): void {
        this.expandedRightPanel = false;
        this.expandedRightPanel$.next(this.expandedRightPanel);
    }

    toggleRightPanel(): void {
        this.expandedRightPanel = !this.expandedRightPanel;
        this.expandedRightPanel$.next(this.expandedRightPanel);
    }
}
